/* global axios */
import ApiClient from './ApiClient';

class ReportingAPI extends ApiClient {
  constructor() {
    super('reporting_events', { accountScoped: false });
  }

  reportConversation(params) {
    const { conversationId, inboxId, type, actions, conversation_id, agent_name } = params;
    return axios.post('/api/v1/reporting_events', {
      type,
      inbox_id: inboxId,
      conversation_id: conversation_id || conversationId,
      actions: actions,
      agent_name: agent_name,
    });
  }
}

export default new ReportingAPI(); 